import { upsellPageAnalyticsRecordDbParser } from "@redotech/redo-model/one-click-upsell/upsell-page-analytics-record";
import * as z from "zod";

export const getPostPurchaseAnalyticsByCheckoutToken = {
  name: "getPostPurchaseAnalyticsByCheckoutToken" as const,
  input: z.object({ checkoutToken: z.string() }),
  output: z.object({
    analyticsRecord: upsellPageAnalyticsRecordDbParser.nullable(),
  }),
};
